var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhitePlus(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "61px",
    height: "62px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(244, 242, 246)",
    d: "M55.666,31.476 L38.991,35.951 L43.453,52.630 C44.452,56.365 42.235,60.204 38.501,61.207 C36.635,61.707 34.741,61.404 33.191,60.509 C31.640,59.614 30.431,58.126 29.932,56.259 L25.469,39.580 L8.793,44.55 C6.926,44.556 5.34,44.252 3.483,43.357 C1.932,42.462 0.723,40.974 0.223,39.107 C0.774,35.372 1.441,31.533 5.176,30.530 L21.851,26.55 L17.389,9.376 C16.390,5.641 18.606,1.802 22.341,0.800 C26.74,0.201 29.911,2.14 30.910,5.747 L35.372,22.427 L52.48,17.951 C55.782,16.950 59.619,19.165 60.618,22.899 C61.617,26.634 59.400,30.473 55.666,31.476 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePlus);
export default __webpack_public_path__ + "static/media/white-plus.9eae8130de3ed2ae6a02a7feeeb8f60b.svg";
export { ForwardRef as ReactComponent };